import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { TimelineMax, Power1 } from "gsap";
import Tilt from 'react-tilt'
import theme from '../../theme';

class ProjectItem extends React.Component {
  constructor(props) {
    super(props);

    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    const { delay, itemId } = this.props;

    this.timeline
      .from(this.box, {
        autoAlpha: 0,
        y: 30,
        duration: 1.4,
        ease: Power1.ease,
        delay: delay * itemId
      })

    this.timeline.play();
  }

  render() {
    const { name, link, main_image } = this.props.project;

    return (
      <Tilt className="Tilt" options={{ max: 10, scale: 1.04 }}>
        <LinkWrapper>
          <Link to={`/${window.language}/${window.projectLink}/${link}`}>
            <Box ref={box => (this.box = box)} >
              <div className="inner-element">
                <ImageWrapper>
                  <img src={main_image} alt="Test" />
                  <div className="overlay">
                    <h3 className="box-text">{name}</h3>
                  </div>
                </ImageWrapper>
              </div>
            </Box>
          </Link>
        </LinkWrapper>
      </Tilt>
    )
  }
}

const LinkWrapper = styled.div`
  a {
    &:hover {
      .overlay {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`

const Box = styled.div`
  width: 100%;
  height: 100%;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 30px;

  img {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;

  .overlay {
    .box-text {
      color: ${theme.colors.primary};
      margin-top: 15px;
    }
  }

  @media(min-width: 992px) {
    .overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(10, 31, 48, 0.68);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .3s ease;
      opacity: 0;
      visibility: hidden;
  
      .box-text {
        color: white;
        font-size: 21px;
        font-weight: 100;
        letter-spacing: .2px;
        padding: 0 18px;
        margin: 0;
      }
    }
  }

`

export default ProjectItem;